const RequiredLabel = ({ text }) => (
  <span>
    {text} <span style={{ color: "red" }}>*</span>
  </span>
);

export default RequiredLabel;